<div class="ibox-content mb-4">
  <form [formGroup]="form" (ngSubmit)="salvar()" (keydown.enter)="$event.preventDefault()">
    <div class="form-body row">
      <h4>Órgãos/Itens</h4>
      <div class="session-body">
        <div class="system-table">
          <div class="system-table-conteiner" >
            <app-ordem-drop class="table-type-1"
              title="Órgao" key="agencyPf" child="tb_org_orgao_many"
              codeKey="num_codigo_pk" titleKey="str_nome" keyId="num_codigo_pk"
              [hasMinutes]='true' [editMinutes]='false'
              [data]="data?.agencyPf"
              [parentFormGroup]="form"
              [tmplRef]="tmplRef"
              (orderItem)="drop($event, data?.agencyPf, form.get('agencyPf'),'num_codigo_pk')"
            >
              <ng-template #tmplRef let-data>
                  <app-ordem-drop *ngIf="data.data.length > 0"
                    title="Órgao" key="agencyPf" child="project_full"
                    codeKey="num_codigo_pk" titleKey="str_nome" keyId="num_codigo_pk"
                    [hasMinutes]='true' [editMinutes]='true'
                    [tmplRef]="tmplProjectFull"
                    [data]="data.data"
                    [parentFormGroup]="data.parentFormGroup"
                    (orderItem)="drop($event, data.data, data.parentFormGroup.get('agencyPf'), 'num_codigo_pk')"
                  >
                    
                </app-ordem-drop>
                
                <app-ordem-drop *ngIf="data.data.length == 0"
                
                  title="Projeto"  key="projectFull" child="pf_indicator"
                  codeKey="year" titleKey="title" keyId="id"
                  [tmplRef]="tmplPfIndicator"
                  [data]="data.data"
                  [parentFormGroup]="data.parentFormGroup"
                  (orderItem)="drop($event, data.data, data.parentFormGroup.get('projectFull'), 'id')"
                >
                </app-ordem-drop>
              </ng-template>
              <ng-template #tmplProjectFull let-data2>
                <app-ordem-drop
                  title="Projeto" key="projectFull" child="pf_indicator"
                  codeKey="year"id titleKey="title" keyId="id"
                  [tmplRef]="tmplPfIndicator"
                  [data]="data2.data"
                  [parentFormGroup]="data2.parentFormGroup"
                  (orderItem)="drop($event, data2.data, data2.parentFormGroup.get('projectFull'), 'id')"
                >
                </app-ordem-drop>
              </ng-template>
              <ng-template #tmplPfIndicator let-data3>
                <app-ordem-drop class="table-type-2"
                  title="Indicador" key="pfIndicator" child="pf_ind_critical"
                  codeKey="code" titleKey="title" keyId="id"
                  [tmplRef]="tmplPfIndCritical"
                  [data]="data3.data"
                  [parentFormGroup]="data3.parentFormGroup"
                  (orderItem)="drop($event, data3.data, data3.parentFormGroup.get('pfIndicator'), 'id')"
                >
                </app-ordem-drop>
              </ng-template>
              <ng-template #tmplPfIndCritical let-data4>
                <app-ordem-drop class="table-type-3"
                  title="Ponto crítico" key="pfIndCritical" child="pf_ind_action"
                  codeKey="id" titleKey="description" keyId="id"
                  [tmplRef]="tmplPfIndAction"
                  [data]="data4.data"
                  [parentFormGroup]="data4.parentFormGroup"
                  (orderItem)="drop($event, data4.data, data4.parentFormGroup.get('pfIndCritical'), 'id')"
                >
                </app-ordem-drop>
              </ng-template>
              <ng-template #tmplPfIndAction let-data5>
                <app-ordem-drop class="table-type-4"
                  title="Plano de ação" key="pfIndAction"
                  codeKey="id" titleKey="title" keyId="id"
                  [data]="data5.data"
                  [parentFormGroup]="data5.parentFormGroup"
                  (orderItem)="drop($event, data5.data, data5.parentFormGroup.get('pfIndAction'), 'id')"
                >
                </app-ordem-drop>
              </ng-template>
            </app-ordem-drop>
          </div>
        </div>
      </div>
    </div>
  <div class="hr-line-dashed"></div>
  <div class="form-group row d-flex justify-content-end">
    <div class="col-sm-8 col-sm-offset-2 d-flex justify-content-end">
      <button class="btn btn-white m-r-xs" type="button" (click)="voltar()">Voltar</button>
      <button class="btn btn-primary" type="submit">Salvar</button>
    </div>
  </div>
  
</form>
</div>
<app-loading [loader]="isLoading"></app-loading>